import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Signup_fortuneWheel'
import themeBase from './_themeBase'
import INDEX from './_index'
import _cloneDeep from 'lodash/cloneDeep'

const info =  _cloneDeep(baseInfo)
const json =  _cloneDeep(baseJson)
const templateID = info.templateID + INDEX

info.templateID = templateID
info.name = 'New Year: ' + info.name
info.priority = 30
json.theme =  _cloneDeep(themeBase.theme)
json.templateID = templateID

const colorPalette = {
  white: '#FEFEFE',
  black: '#161a1e',
  customColor: '#e39b85',
}

// Override primary and secondary colors
json.theme.headline.color = colorPalette.customColor // White for headlines
json.theme.text.color = colorPalette.customColor // #e39b85 for general text
json.theme.button.backgroundColor = colorPalette.customColor // #e39b85 for button backgrounds
json.theme.button.color = colorPalette.white // White text on buttons
json.theme.button.borderColor = colorPalette.customColor // #e39b85 border on the wheel
json.theme.voucher.color = colorPalette.white // White text for vouchers
json.theme.voucher.borderColor = colorPalette.customColor // #e39b85 border for vouchers
json.theme.field.color = colorPalette.customColor // #e39b85 for field text
json.theme.field.borderColor = colorPalette.customColor // #e39b85 borders for fields
json.theme.survey.color = colorPalette.customColor // #e39b85 for survey text
json.theme.survey.borderColor = colorPalette.customColor // #e39b85 borders for survey
json.theme.wheel.color = colorPalette.black // White text on the wheel
json.theme.wheel.borderColor = colorPalette.customColor // #e39b85 border on the wheel
json.theme.wheel.backgroundColor = colorPalette.customColor
json.theme.wheel.secondaryBackgroundColor = colorPalette.white
json.theme.checkbox.color = colorPalette.white // #e39b85 for checkbox tick
json.theme.checkbox.borderColor = colorPalette.customColor // #e39b85 borders for checkboxes
json.theme.checkbox.checkboxColor = colorPalette.customColor // #e39b85 background for checkboxes
json.theme.social.color = colorPalette.customColor // #e39b85 for social icons

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#090909',
  backgroundImage: 'url("https://assets.onvocado.com/templates/ny_bg.png")',
}

// Set New Year-themed font
const newYearFont = 'Montserrat'

// Modify content items as needed
json.steps[0].contentItems = json.steps[0].contentItems.map((item) => {
  if (item.type === 'headline') {
    item.content.text = 'New Year\'s with Amazing Prizes!'
    item.styling.fontFamily = newYearFont
    item.styling.fontSize = '32px'
  }
  if (item.type === 'text') {
    item.content.text = '<p>Celebrate the New Year! <strong>Spin the wheel</strong> for your chance at great discounts and gifts!</p>'
    item.styling.fontFamily = newYearFont
  }
  if (item.type === 'button') {
    item.content.text = 'Spin & Win'
    item.styling.fontFamily = newYearFont
  }
  if (item.type === 'field' || item.type === 'voucher') {
    item.styling.fontFamily = newYearFont
  }
  return item
})

export { json, info }
